import { render, staticRenderFns } from "./DonutChart59.vue?vue&type=template&id=55ed2cfa&scoped=true&"
import script from "./DonutChart59.vue?vue&type=script&lang=js&"
export * from "./DonutChart59.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed2cfa",
  null
  
)

export default component.exports